// api client
import { client } from '../api/client'
import { Linking } from 'react-native'
import { Platform } from 'react-native'
import axios from 'axios'
import * as WebBrowser from 'expo-web-browser'
import * as FileSystem from 'expo-file-system'
// types
import {
  ImageMimeTypes,
  FileMimeTypes,
  ImageBase64,
  FileBase64,
  Form,
  ModetailsData
} from '../types/onboardingTypes'

/**
 * Pick an image from photo library
 *
 * @returns Promise<ImageBase64<ImageMimeTypes>>
 */

const uploadImage = (): Promise<ImageBase64<ImageMimeTypes>> => {
  return new Promise(async (resolve, reject) => {
    try {
      if (true) {
        // TODO call API
        resolve('data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...')
      } else {
        reject({ message: 'Could not upload image' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * Upload a document (the document could image or pdf)
 *
 * @returns Promise<ImageBase64<ImageMimeTypes> | FileBase64<FileMimeTypes>>
 */
const uploadDocument = (): Promise<
  ImageBase64<ImageMimeTypes> | FileBase64<FileMimeTypes>
> => {
  return new Promise(async (resolve, reject) => {
    try {
      if (true) {
        // TODO call API
        resolve('data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...')
      } else {
        reject({ message: 'Could not upload document' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * Get all forms
 *
 * @param id
 * @returns Promise<Form[]>
 */
const fetchData = (id: number): Promise<Form[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const { status, data } = await client.get(`/OnBoarding/${id}/Forms`)

      if (status === 200) {
        resolve(data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * Personal post data
 *
 * @returns Promise<Form[]>
 */
const postData = (
  id: number,
  formId: number,
  isdirectdeposit: boolean,
  data: FormData,
  updateProgress: (progress: number) => void
): Promise<Form[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/${id}/Form/${formId}?isDepositForm=${isdirectdeposit}`,
        data,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            let { progress } = progressEvent
            updateProgress(Math.round(progress * 100))
          }
        }
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * Mark document as read
 *
 * @param id
 * @param formId
 * @returns Promise<Form[]>
 */
const markDocAsRead = (id: number, formId: number): Promise<Form[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.patch(
        `/OnBoarding/${id}/Form/${formId}/MarkAsRead`
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not mark it as read' })
      }
      return null
    } catch (error) {
      reject(error)
    }
  })
}

const postW4Data = (data): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/OnBoarding/InsertW4Details`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getw4Details = (formkey, obkey): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/OnBoarding/GetW4DetailsForm?FormKey=${formkey}&OnBoardingKey=${obkey}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const submittedForm = (formkey, obkey) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetSubmittedForm?FormKey=${formkey}&OnBoardingKey=${obkey}`,
        { responseType: 'arraybuffer' }
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const posti9details = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/OnBoarding/PostI9Details`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postdirectdepositonline = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`Shift/SubmitDepositForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postalonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/PostALWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postiowaonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/PostIOWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postwotconline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostWOTCDetails`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postlaonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/PostLAWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postgaonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/PostGeorgiaWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postcaonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/PostCAWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postaronline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostARWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postkyonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostKYWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postctonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/PostCTWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postazonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostAZWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postcoonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostCOWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postdconline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostDCWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postdeonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostDEwithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postidonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostIDWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const posthionline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostHIWithHoldingDetails`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postpaonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostPAResidency`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postMaOnline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostMAwithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postMdOnline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostMDwithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postKarnsOnline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostKarnsHandBookForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postWCRightsOnline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostPARightsandDutiesForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postEEOOnline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostEEOForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postKSonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostKSWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postokonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostOKwithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postvaonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostVAWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const post8850online = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostPSCRwithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postoronline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostORForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postmoonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostMOWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getmodetails = (id: number): Promise<ModetailsData> => {
  return new Promise(async (resolve, reject) => {
    try {
      const { status, data } = await client.get(
        `/OnBoarding/GetEmployerDetails?EssUserKey=${id}`
      )

      if (status === 200) {
        resolve(data)
      } else {
        reject({ message: 'Could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postgrenadehandbook = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostGroceryBasketEmployeeHandbook`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postgrenadepolicy = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostGroceryBasketCellphonePolicy`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postmsonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostMSWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postilonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostILWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postwionline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostWIWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postinonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostINWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postmtonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostMTWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postrionline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostRIWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postneonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostNEWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postsconline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostSCWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postvtonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostVTWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postwvonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostWVWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postmeonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostMaineWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postohonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostOHWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const previewReadonlyForms = async (formId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetFormPreview?FormKey=${formId}`,
        { responseType: 'arraybuffer' }
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postmionline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostMIWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postnmonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostNMWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postnconline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostNCWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postnjonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostNjWithholdingForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postredmondoperations = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostGroceryAcknowledgmentForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postredmondhandbook = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostEmployeeHandbookAcknowledgmentForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postnyonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostNyForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postrobertsverification = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostRobertsForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getinstates = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get('OnBoarding/GetIndianaCounty')
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getpapsdcodes = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetPAPSDCodes?EssUserKey=${data}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postmnonline = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostMNWithholdingForm`,
        data
      )
      if (response && response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (err) {
      reject(err)
    }
  })
}

const postHandBookSignOff = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostJprouxlReceipt`, data)
      if (response && response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (err) {
      reject(err)
    }
  })
}
const postWakeFieldForm = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding//PostWakefieldDetails`,
        data
      )
      if (response && response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (err) {
      reject(err)
    }
  })
}

const downloadFile = async (essFormKey) => {
  try {
    const apiResponse = await client.get(
      `/OnBoarding/DownloadForm?id=${essFormKey}`
    )

    const Filesdata = apiResponse.data
    const fileUrl = Filesdata.uri
    // if (Platform.OS === 'web') {
    //   Linking.openURL(fileUrl);
    // }
    if (Platform.OS === 'web') {
      const base64 = Filesdata.uri // Assuming this is the base64 string

      // Convert base64 to binary string
      const byteCharacters = atob(base64?.split(',')[1] || base64) // handle optional data prefix
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512)
        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      const blob = new Blob(byteArrays, { type: 'application/pdf' })
      const blobUrl = URL.createObjectURL(blob)

      // Open the PDF in a new tab
      Linking.openURL(blobUrl)
    } else {
      const fileName = Filesdata.name
      const filePath = `${FileSystem.documentDirectory}${fileName}`
      const { uri } = await FileSystem.downloadAsync(fileUrl, filePath)
      await WebBrowser.openBrowserAsync(uri)
    }
  } catch (error) {
    console.error('Error:', error)
  }
}

const getImagePreviewUri = async (
  essFormKey,
  obkey,
  stateValue?: string,
  pageNumber?: number
): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    try {
      // const response = await client.get(
      //   `OnBoarding/GetSubmittedForm?FormKey=${essFormKey}&OnBoardingKey=${obkey}&preview=true`,
      //   { responseType: 'arraybuffer' }
      // )

      const response = await client.get(
        `OnBoarding/GetSubmittedForm?FormKey=${essFormKey}&OnBoardingKey=${obkey}&preview=true${stateValue ? `&stateValue=${stateValue}` : ''}${pageNumber ? `&page=${pageNumber}` : ''}`,
        { responseType: 'arraybuffer' }
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not get data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postRonsHandBook = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/RonsCompanyHandbook`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const PostCityMarketForm = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostCityMarketForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const PostDavisForm = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostDavisFoodAndDrugForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postOHAutomation = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/OhioStateTaxDetails`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postFoodCountry = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `/OnBoarding/PostFoodCountryForm`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const PostGalensForm = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`/OnBoarding/PostGalensForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getRequestFormsList = async (entityId: number, obkey: number | null) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/OnBoarding/GetRequestFormsList?EntityID=${entityId}&essUserOnboardingKey=${obkey}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postRequestFormList = async (data: number) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/SubmitRequestForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const postVowellsForm = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(`OnBoarding/PostVowellsForm`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const postSMMarketsOnline = async (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post(
        `OnBoarding/PostSMMEmployeeHandbook`,
        data
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

export const onboardingService = {
  uploadImage,
  uploadDocument,
  fetchData,
  postData,
  markDocAsRead,
  downloadFile,
  postW4Data,
  getw4Details,
  submittedForm,
  posti9details,
  postdirectdepositonline,
  postalonline,
  postiowaonline,
  postwotconline,
  postlaonline,
  postgaonline,
  postcaonline,
  postaronline,
  postkyonline,
  postctonline,
  postazonline,
  postcoonline,
  postdconline,
  postdeonline,
  postidonline,
  posthionline,
  postpaonline,
  postMaOnline,
  postMdOnline,
  postKarnsOnline,
  postWCRightsOnline,
  postEEOOnline,
  postKSonline,
  postokonline,
  postvaonline,
  post8850online,
  postoronline,
  postmoonline,
  getmodetails,
  postgrenadehandbook,
  postgrenadepolicy,
  postmsonline,
  postilonline,
  postwionline,
  postinonline,
  postmtonline,
  postrionline,
  postneonline,
  postsconline,
  postvtonline,
  postwvonline,
  postmeonline,
  postohonline,
  previewReadonlyForms,
  postmionline,
  postnmonline,
  postnconline,
  postnjonline,
  postredmondoperations,
  postredmondhandbook,
  postnyonline,
  postrobertsverification,
  getinstates,
  getpapsdcodes,
  postmnonline,
  postHandBookSignOff,
  postWakeFieldForm,
  getImagePreviewUri,
  postRonsHandBook,
  PostCityMarketForm,
  PostDavisForm,
  postOHAutomation,
  postFoodCountry,
  PostGalensForm,
  getRequestFormsList,
  postRequestFormList,
  postVowellsForm,
  postSMMarketsOnline
}
